import React from 'react';

const MyContext = React.createContext({isWidgetOpen: false, toggleWidgetContext: ()=> {}});

export default MyContext;